import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AppPartName, Login } from "Utils/analytics";
import { AnalyticsProduct, AnalyticsState, Page } from "./analyticsInterfaces";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { AddProduct } from "Store/addProductToCart/interfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { FeatureFlag } from "Utils/unleash/flags";

const initialState: AnalyticsState = {
  products: [],
  usedFeatureFlags: [],
  loginMethod: Login.NIN,
};

interface PageDisplayedPayload {
  pageName: AppPartName | string;
  product?: INSURANCE_NAME_VALUE | ProductBackendName;
}

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    setCheckPriceProducts: (
      state,
      action: PayloadAction<AnalyticsProduct[]>,
    ) => {
      state.products = action.payload;
    },

    setCurrentAppPart: (state, action: PayloadAction<AppPartName>) => {
      state.appPart = action.payload;
    },

    pageDisplayed: (state, action: PayloadAction<PageDisplayedPayload>) => {
      state.previousPage = state.page;
      state.page = {
        name: action.payload.pageName,
      };
      if (action.payload.product) {
        state.products = [action.payload.product];
      }
    },

    productAddedToCart: (state, action: PayloadAction<AddProduct[]>) => {
      state.productsAddedToCart = action.payload;
    },

    clearProductAddedToCart: (state) => {
      state.productsAddedToCart = undefined;
    },

    cartFetched: () => {
      // no state change
    },

    orderComplete: () => {
      // no state change
    },

    componentClicked: (_state, _action: PayloadAction<string>) => {
      // no state change
    },

    setPage: (state, action: PayloadAction<Page>) => {
      state.previousPage = state.page;
      state.page = action.payload;
    },

    setFeatureFlagUsed: (state, action: PayloadAction<FeatureFlag>) => {
      if (!state.usedFeatureFlags.some((flag) => flag === action.payload)) {
        state.usedFeatureFlags = [...state.usedFeatureFlags, action.payload];
      }
    },

    setLoginMethod: (state, action: PayloadAction<Login>) => {
      state.loginMethod = action.payload;
    },
  },
});

export const {
  pageDisplayed,
  productAddedToCart,
  clearProductAddedToCart,
  cartFetched,
  orderComplete,
  setCheckPriceProducts,
  setCurrentAppPart,
  setFeatureFlagUsed,
  setLoginMethod,
  setPage,
  componentClicked,
} = analyticsSlice.actions;
export const analytics = analyticsSlice.reducer;
